export default class SmoothScroll {
  constructor() {
    this.elementsHolder = $("a[data-scroll]");
    this.offset = $('.header-main').outerHeight();

    // init call
    this.addListener();
  }

  addListener = () => {
    const { handleClick } = this;
    const elementsHolder = Array.from(this.elementsHolder);

    elementsHolder.forEach((el) => el.addEventListener("click", handleClick));
  };
c
  handleClick = (e) => {
    e.preventDefault();
    const eventTarget = e.currentTarget;
    const anchor = eventTarget.getAttribute("href");
    const speed = eventTarget.getAttribute("data-speed");
    const offset = eventTarget.getAttribute("data-offset") || this.offset;

    this.handleScroll(anchor, speed, offset);
  };

  handleScroll = (anchor, speed = 1000, offset = 80) => {
    SmoothScroll.scrollTo($(anchor), speed, offset);
  };

  static scrollTo($section, speed = 1000, offset = 80) {
    $("html, body").animate(
      {
        scrollTop: $section.offset().top - offset,
      },
      speed
    );
  }
}
